<template>
  <div>
    <common-dialog
      ref="dialog"
      width="900px"
      title="详情 角色"
      id-key="RoleId"
      form-label-width="110px"
      :data="data"
      :get-data-func="api.getRoleWithMenu"
      @details-opened="onDetailsOpened"
    >
      <template slot="form">
        <el-row>
          <el-col :span="$store.state.isMB?24:12">
            <el-form-item label="角色名称" prop="RoleName">
              <span>{{data.RoleName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="$store.state.isMB?24:12">
            <el-form-item label="状态" prop="Status">
              <el-tag size="mini" v-if="data.Status==1" type="success">启用</el-tag>
              <el-tag size="mini" v-else type="danger">屏蔽</el-tag>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="序号" prop="Sort">
          <span>{{data.Sort}}</span>
        </el-form-item>
        <el-form-item label="描述" prop="Remark">
          <span>{{data.Remark}}</span>
        </el-form-item>
        <el-form-item label="数据阅读权限" prop="DataRange" :class="$store.state.isMB?'setMargin':''">
          <span v-if="data.DataRange==0">所有</span>
          <span v-if="data.DataRange==1">本部门</span>
          <span v-if="data.DataRange==2">本部门以及下属部门</span>
        </el-form-item>
        <div v-if="$store.state.isMB" style="margin-bottom:10px;">功能权限操作</div>
        <el-form-item
          :label="$store.state.isMB?'':'功能操作权限'"
          :label-width="$store.state.isMB?'0':''"
        >
          <el-table size="mini" :data="Menus" row-key="MenuId" border stripe default-expand-all>
            <el-table-column label="菜单名称" :width="$store.state.isMB?'150px':''">
              <template slot-scope="{row}">{{ row.MenuName }}</template>
            </el-table-column>
            <el-table-column label="权限">
              <template slot-scope="{row}">
                <span v-for="(chk,$index) in row.MenuFuncs" :key="$index">
                  <span v-if="chk.Checked==true">{{chk.FuncName}}、</span>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </template>
      <template slot="footer">
        <el-button size="mini" @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import editDialogMixin from "@/mixins/editDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        RoleId: 0,
        RoleName: "",
        Remark: "",
        Sort: 0,
        Status: 1,
        DataRange: 0,
      },
      Menus: [],
      api: require("@/api/sy/role").default,
    };
  },
  computed: {},
  methods: {
    onDetailsOpened(data) {
      this.api.getRoleWithMenu(data.RoleId).then((res) => {
        let menus = res.Data.Menus;
        this.Menus = this.$commonJs.toTreeData(menus, "MenuId");
      });
    },
  },
};
</script>
<style lang="scss">
.setMargin {
  .el-form-item__label {
    padding-left: 15px;
  }
  .el-radio {
    margin-bottom: 10px;
  }
}
</style>